/**
 * Erweitert JQuery um ein Event, das getriggert wird, sobald das Element vom DOM entfernt wird.
 * Sinnvoll für interne Aufräumroutinen. Das Event wird nicht bei detach getriggert.
 * Klappt nur, wenn die DOM-Manipulation über JQuery läuft.
 * @example
 * $(myElement).on('removedFromDom',()=>alert('myElement wurde aus dem DOM entfernt'));
 */
jQuery.event.special.removedFromDom = {
    remove: function(o) {
        if (o.handler) {
            o.handler();
        }
    }
};

/**
 * Zentriert ein Element absolut in der Mitte des Windows
 * @example
 * $('.dialog').center();
 */
jQuery.fn.center = function() {
    this.css("position", "absolute");
    this.css("top", Math.max(0, (($(window).height() - $(this).outerHeight()) / 2) + $(window).scrollTop()) + "px");
    this.css("left", Math.max(0, (($(window).width() - $(this).outerWidth()) / 2) + $(window).scrollLeft()) + "px");
    return this;
};

jQuery.fn.scrollBottom = function() {
    this.scrollTop(this[0].scrollHeight - this[0].clientHeight)
};

/**
 * Zeigt das Element an, wenn true, sonst wird es verborgen.
 * @example
 * $('.dialog').showIf(false);
 */
jQuery.fn.showIf = function(when) {
    if (when) {
        this.show();
    } else {
        this.hide();
    }
    return this;
};

/**
 * Setzt eine Klasse, wenn true, sonst wird sie entfernt
 * @example
 * $('.dialog').setClassIf('active',false);
 */
jQuery.fn.setClassIf = function(clazz, when) {
    if (when) {
        this.addClass(clazz);
    } else {
        this.removeClass(clazz);
    }
    return this;
};

/**
 * Setzt ein Attribut (wie disabled="disabled"), wenn true, sonst wird es entfernt.
 * @example
 * $('.dialog').setAttrIf('disabled',false);
 */
jQuery.fn.setAttrIf = function(attribute, when, value=undefined) {
    if (when) {
        this.attr(attribute, value==null ? attribute : value);
    } else {
        this.removeAttr(attribute);
    }
    return this;
};

/**
 * Setzt die Klasse 'disabled' oder bei Form-Elementen das Attribut disabled, wenn true, sonst wird sie/es entfernt
 * @example
 * $('.dialog').disable(true);
 */
jQuery.fn.disable = function (bool=false) {
    if (/^(button|input|textarea|select)$/ig.test(this.prop("tagName"))) {
        if (bool) {
            this.attr('disabled','disabled');
        } else {
            this.removeAttr('disabled');
        }
    } else {
        if (bool) {
            this.addClass('disabled');
        } else {
            this.removeClass('disabled');
        }
    }
    return this;
};

/**
 * Wie on, aber:
 * 1. gibt als ersten Parameter an das Callback stets die Referenz auf das Element mit, womit die Verwendung von Clojures möglich wird.
 * 2. Falls das Element die Class 'disabled' gesetzt hat, wird das Callback nicht ausgeführt.
 * @example
 * $('.dialog').onSafe('click',(element)=>element.addClass('active'));
 *
 * // ab dann ist der Listener nicht mehr aktiv
 * $('.dialog').disable();
 */
jQuery.fn.onSafe = function (name,callback) {
    const callbackWrapper = function() {
        var self = jQuery(this);
        if (self.hasClass('disabled') || self.attr('disabled')!=null) {
            return;
        }
        var args = [self];
        args.push.apply(args,arguments);
        callback.apply(self,args);
    };
    callbackWrapper.originalCallback = callback;
    this.on(name,callbackWrapper);
    return this;
}


/**
 * ermöglicht forEach mit gewohnter ES6-Syntax auf einem Selektor
 * @param iterator
 */
jQuery.fn.forEach = function(iterator=(element,index)=>{}) {
    this.each((index,element)=>iterator($(element),index));
}

/**
 * Löscht temporär eine Reihe von headern aus den ajaxSettings.headers. Somit kann man einen einzelnen Ajax-Call
 * ausführen ohne bestimmte Standard-Header.
 * @example
 * $.performWithoutHeaders(['X-CSRF-Token'],()=>{
 *    $.get('http://test-traumgarten.raphael-gmbh.de/api/product/properties');
 * });
 */
jQuery.performWithoutHeaders = function(headerNames,safeCallback) {
    const saved = {};
    headerNames.forEach(key=>{
        saved[key]=$.ajaxSettings.headers[key];
        delete $.ajaxSettings.headers[key];
    });
    safeCallback();
    headerNames.forEach(key=>{
        if (saved[key]===undefined) {
            $.ajaxSettings.headers[key] = saved[key];
        }
    });
}

